import { connect } from 'react-redux';
import isNil from 'lodash/isNil';
import View from './LifeView';
import MobileView from '../../../MobileFinancialPlan/MobileInsurance/MobileLife/MobileLifeView';
import { setReactCalibrationWidget, updateGoalViewState } from '../../FinancialPlanActions';
import { getSubgoal, getNote } from './LifeHelpers';
import {
  selectedIndex as selectedOwnerIndex,
  selectedOwnerName,
} from '../OwnerDropdown/OwnerDropdownSelector';
import { insuranceNotes } from '../NotesPopup/NotesPopupSelector';

const mapStateToProps = (state, ownProps) => {
  const selectedGoal = getSubgoal(ownProps.insuranceGoal);
  const ownerDropdownProps = {
    clientId: ownProps.clientId,
    goalId: ownProps.goalId,
    subgoalId: ownProps.selectedSection,
    spouseName: selectedGoal.DisabilityInsurance.SpouseName,
    principalName: selectedGoal.DisabilityInsurance.PrincipalName,
    selectedGoal,
  };
  return {
    selectedGoal,
    note: getNote(insuranceNotes(state, ownerDropdownProps)),
    subgoalData: selectedGoal.LifeInsurance,
    subgoalId: ownProps.selectedSection,
    selectedOwnerIndex: !isNil(ownProps.selectedOwnerIndex)
      ? ownProps.selectedOwnerIndex
      : selectedOwnerIndex(state, ownerDropdownProps),
    selectedOwnerName: ownProps.selectedOwnerName || selectedOwnerName(state, ownerDropdownProps),
    title: ownProps.title,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
  setSelectedOwnerIndex: (clientId, goalId) => ownerIndex => event => {
    dispatch(
      updateGoalViewState(goalId, clientId, {
        ownerIndex,
      }),
    );
  },
  setSelectedTabIndex: (clientId, goalId, subgoalId) => tabIndex => event => {
    dispatch(
      updateGoalViewState(goalId, clientId, {
        subgoals: {
          [subgoalId]: {
            tabIndex,
          },
        },
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileLife = connect(mapStateToProps, mapDispatchToProps)(MobileView);
